import AddressFieldToggle from './AddressFieldToggle'

// function AddressFieldToggle({ children }: { children: ReactNode }) {
//   return (
//     <ABTest
//       flag={FeatureFlagKey.ExpressCheckout}
//       fallback={<AddressFieldToggleControl>{children}</AddressFieldToggleControl>}
//     >
//       <ABTest.Option value="test">
//         <AddressFieldToggleTestGroup>{children}</AddressFieldToggleTestGroup>
//       </ABTest.Option>
//       <ABTest.Option value="control">
//         <AddressFieldToggleControl>{children}</AddressFieldToggleControl>
//       </ABTest.Option>
//     </ABTest>
//   )
// }

export default AddressFieldToggle
